import { extractNationalNumber } from 'utils';

export const getCreateWorkerParams = (values: any) => {
  const hasMobilePhoneNumber = extractNationalNumber(values.mobilePhoneNumber);
  return {
    ...(values.email ? { email: values.email?.trim() } : {}),
    ...(hasMobilePhoneNumber ? { mobilePhoneNumber: values.mobilePhoneNumber } : {}),
    firstName: values.firstName?.trim(),
    lastName: values.lastName?.trim(),
    inviteMethod: values.email && hasMobilePhoneNumber ? 3 : values.email ? 1 : hasMobilePhoneNumber ? 2 : 0,
    isAddingFromTablet: true,
    companyIds: values?.employers?.map(e => e.value),
    activateWorker: true,
    dateOfBirth: values.dateOfBirth
      ? typeof values.dateOfBirth === 'string'
        ? values.dateOfBirth
        : values.dateOfBirth.toISOString()
      : undefined,
    languageCode: values?.languageCode,
    isPendingInvitationWorker: values.email || hasMobilePhoneNumber ? false : true,
  };
};
